import { render, staticRenderFns } from "./AppShowcase.vue?vue&type=template&id=cbfa9484&scoped=true&"
import script from "./AppShowcase.vue?vue&type=script&lang=js&"
export * from "./AppShowcase.vue?vue&type=script&lang=js&"
import style0 from "./AppShowcase.vue?vue&type=style&index=0&id=cbfa9484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa9484",
  null
  
)

export default component.exports